import React from 'react';
import { Modal } from 'react-bootstrap';
import CobrancasDepositoTable from '../../Cobrancas/components/CobrancasDepositoTable';
import { useDepositoNotaFiscalCobrancas } from '../hooks/useDepositoNotaFiscalCobrancas';

const DepositoNotaFiscalCobrancasModal = ({ show, onHide, notaId, numeroNF }) => {
  const {
    data,
    loading,
    totalRegistros,
    paginationState,
    setPaginationState,
    cancelandoCobranca,
    handleCancelarCobranca
  } = useDepositoNotaFiscalCobrancas(numeroNF, show);

  const modalTitle = numeroNF ? `Cobranças - NF ${numeroNF}` : 'Cobranças';

  return (
    <Modal show={show} onHide={onHide} size="xl" backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!notaId ? (
          <div className="text-muted">Selecione uma nota fiscal para visualizar cobranças.</div>
        ) : (
          <>
            <div className="text-muted mb-2">Total de registros: {totalRegistros}</div>
            <CobrancasDepositoTable
              data={data}
              loading={loading}
              totalRegistros={totalRegistros}
              paginationState={paginationState}
              setPaginationState={setPaginationState}
              onCancelarCobranca={handleCancelarCobranca}
              cancelandoCobranca={cancelandoCobranca}
            />
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default DepositoNotaFiscalCobrancasModal;
